import React, { useEffect, useState } from "react";

import { getProjectDescApi } from "../../../Trust/api/Project";

const SITE_PROGRESS_IMAGE = "images/Land 2.png";
const CONSTRUCTION_LAND_SIZE = "200 Sq Yard (1800 Sq Feet)";
const CONSTRUCTION_RATE = "₹1,500 Per Sq Foot";

const Row = ({
  label,
  value,
}: {
  label: string;
  value: React.ReactNode;
}) => (
  <div className="grid grid-cols-[180px,1fr] gap-2 py-2 border-b border-[#edf0f5] last:border-b-0">
    <span className="text-[#9aa3b2] font-semibold text-sm">{label}</span>
    <span className="text-right font-semibold text-sm text-[#344054]">
      {value}
    </span>
  </div>
);

/* Fund Summary kept for future reference.
import { useEffect } from "react";
import { getProjectDescApi } from "../../../Trust/api/Project";

const LAND_SIZE = "200 Square Yard";
const LAND_COST = "₹1 Cr 58 Lakhs";

const Row = ({
  label,
  value,
}: {
  label: string;
  value: React.ReactNode;
}) => (
  <div className="grid grid-cols-[180px,1fr] gap-2 py-2.5 border-b border-[#edf0f5] last:border-b-0">
    <span className="text-[#9aa3b2] font-semibold text-sm">{label}</span>
    <span className="text-right font-semibold text-sm text-[#344054]">
      {value}
    </span>
  </div>
);
*/

const ACCOUNTS = [
  {
    qrTitle: "Nafl",
    bank: "ICICI",
    branch: "Mothi Nagar",
    ifsc: "ICIC0002366",
    accountNumber: "236605002974",
    upi: "MSTAJUSHSHARIAHFOUNDATION.eazypay@icici",
    accountName: "TajushShariah Foundation",
    qrImage: "images/ICICI.jpg",
    qrAlt: "ICICI QR Code",
  },
];

const TransactionForm = () => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    txRef: "",
    amount: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const text = encodeURIComponent(
      `*Offline Donation — Masjid o Madrasa TajushShariah*\n\n` +
        `Name: ${form.name}\n` +
        `Phone: ${form.phone}\n` +
        `Transaction Ref / UTR: ${form.txRef}\n` +
        `Amount Paid: ₹${form.amount}\n` +
        `Message: ${form.message || "—"}`
    );
    window.open(`https://wa.me/918143917806?text=${text}`, "_blank");
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="text-center py-6">
        <p className="text-green-600 font-semibold text-lg mb-1">
          ✓ Details sent successfully!
        </p>
        <p className="text-sm text-gray-500">
          JazakAllah Khair for your contribution. We will reach out to you
          shortly.
        </p>
        <button
          className="mt-4 text-sm text-[#3f7ff4] underline"
          onClick={() => setSubmitted(false)}
        >
          Submit another
        </button>
      </div>
    );
  }

  const inputCls =
    "w-full border border-[#d0d7e2] rounded-xl px-3 py-2 text-sm focus:outline-none focus:border-[#3f7ff4] focus:bg-[#f6f9ff] transition";

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-semibold text-[#344054] mb-1">
            Your Name *
          </label>
          <input
            required
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Enter your full name"
            className={inputCls}
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-[#344054] mb-1">
            Phone / WhatsApp *
          </label>
          <input
            required
            name="phone"
            value={form.phone}
            onChange={handleChange}
            placeholder="+91 XXXXX XXXXX"
            className={inputCls}
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-[#344054] mb-1">
            Transaction Ref / UTR No. *
          </label>
          <input
            required
            name="txRef"
            value={form.txRef}
            onChange={handleChange}
            placeholder="e.g. 123456789012"
            className={inputCls}
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-[#344054] mb-1">
            Amount Paid (₹) *
          </label>
          <input
            required
            name="amount"
            value={form.amount}
            onChange={handleChange}
            placeholder="e.g. 5000"
            className={inputCls}
          />
        </div>
      </div>
      <div>
        <label className="block text-sm font-semibold text-[#344054] mb-1">
          Message / Additional Note
        </label>
        <textarea
          name="message"
          value={form.message}
          onChange={handleChange}
          rows={3}
          placeholder="Any additional details (optional)"
          className={inputCls}
        />
      </div>
      <button
        type="submit"
        className="inline-flex items-center gap-2 rounded-xl bg-green-500 px-6 py-3 text-white font-semibold shadow-sm hover:bg-green-600 transition-colors"
      >
        Send via WhatsApp
      </button>
      <p className="text-xs text-gray-400 mt-1">
        This will open WhatsApp with your details pre-filled to send to us.
      </p>
    </form>
  );
};

const Announcement1 = () => {
  const url = process.env.REACT_APP_API_URL;
  const [totalBudget, setTotalBudget] = useState<number | null>(null);
  const [totalRemaining, setTotalRemaining] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const projects = await getProjectDescApi(url);
        if (projects && Array.isArray(projects)) {
          const relevant = projects.filter((p: any) =>
            p.name
              ?.toLowerCase()
              .match(/masjid|madrasa/)
          );
          const budget = relevant.reduce(
            (sum: number, p: any) => sum + (Number(p.budget) || 0),
            0
          );
          const remaining = relevant.reduce(
            (sum: number, p: any) => sum + (Number(p.remaining) || 0),
            0
          );
          setTotalBudget(budget);
          setTotalRemaining(remaining);
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [url]);

  const formatCurrency = (amount: number) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);

  return (
    <div className="min-h-screen bg-[#f3f4f8] font-sans">
      <main className="max-w-[860px] mx-auto px-4 py-3 pb-0.5">
        {/* ── Page Title ── */}
        <div className="mb-2">
          <div className="flex flex-col md:flex-row items-center justify-center gap-1.5 md:gap-2.5 mb-1">
            <h1 className="text-xl md:text-3xl font-bold bg-gradient-to-r from-[#1e40af] to-[#f59e0b] bg-clip-text text-transparent drop-shadow-md text-center">
              Support for Masjid o Madrasa TajushShariah
            </h1>
            <img src="images/Taj.png" alt="Taj" className="h-8 md:h-12 w-8 md:w-12 object-contain flex-shrink-0" />
          </div>
          <div className="h-0.5 w-24 md:w-20 mx-auto bg-gradient-to-r from-[#1e40af] to-[#f59e0b] rounded-full shadow-md"></div>
        </div>

        {/* Donation Message */}
        <p className="text-center text-[#1f3f75] mb-1.5 text-xs md:text-sm leading-relaxed font-semibold italic">
          In Shaa Allah, <span className="text-[#b45309] font-normal not-italic">Kuch Deeno Me Registration Ho Jayega</span> Aur <span className="text-[#c026d3] font-normal not-italic">Immediately</span> <span className="text-[#047857] font-normal not-italic">Construction</span> Start Karna He. Aap Is Khair Ke Kaam Mein Zyada Se Zyada Apne Aur Apne Mahroomon Ke Liye Taawun Karein Aur Duniya Aur Akhirat Mein Fayda Pahunchaye.
        </p>

        <section className="bg-white rounded-3xl border border-[#e7e9ee] shadow-sm overflow-hidden mb-1.5">
          <img
            src={SITE_PROGRESS_IMAGE}
            alt="Masjid o Madrasa TajushShariah site progress"
            className="w-full aspect-[16/9] md:aspect-[2.2/1] object-cover"
          />
        </section>

        {/* ── Construction Summary Card ── */}
        <div className="bg-white rounded-3xl border border-[#e7e9ee] shadow-sm p-3 mb-1.5">
          <div className="flex items-center gap-2 mb-2">
            <h2 className="text-base font-semibold text-[#1f3f75]">
              Construction Summary - Basement + Ground + 3 Floors (Approx.)
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3">
            <div>
              <Row label="Land Size" value={CONSTRUCTION_LAND_SIZE} />
              <Row label="Construction Cost" value={CONSTRUCTION_RATE} />
            </div>
            <div>
              <Row
                label="Total Construction Cost"
                value={
                  loading ? (
                    <span className="text-gray-400 italic">Loading…</span>
                  ) : totalBudget !== null ? (
                    <span className="text-amber-600 font-bold">
                      {formatCurrency(totalBudget)}
                    </span>
                  ) : (
                    <span className="text-gray-400">Unavailable</span>
                  )
                }
              />
              <Row
                label="Balance Amount Required"
                value={
                  loading ? (
                    <span className="text-gray-400 italic">Loading…</span>
                  ) : totalRemaining !== null ? (
                    <span className="text-red-500 font-bold">
                      {formatCurrency(totalRemaining)}
                    </span>
                  ) : (
                    <span className="text-gray-400">Unavailable</span>
                  )
                }
              />
            </div>
          </div>
        </div>

        {/* ── Fund Summary Card ── */}
        {/* <div className="bg-white rounded-3xl border border-[#e7e9ee] shadow-sm p-4 mb-2">
          <div className="flex items-center gap-2 mb-3">
            <h2 className="text-lg font-semibold text-[#1f3f75]">
              Fund Summary
            </h2>
            <span className="ml-auto inline-flex items-center gap-1 rounded-full bg-green-100 text-green-700 text-xs font-semibold px-2.5 py-0.5">
              <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse inline-block" />
              Live
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3">
            <div>
              <Row label="Land Size" value={LAND_SIZE} />
              <Row label="Per Square Foot" value="₹8,777" />
              <Row label="Land Cost" value={LAND_COST} />
            </div>
            <div>
              <Row label="Advance Paid" value={<span className="text-green-600 font-bold">₹47.40 Lakhs</span>} />
              <Row label="Balance To Be Paid" value={<span className="text-amber-600 font-bold">₹1 Cr 10.6 Lakhs</span>} />
              <Row
                label="Balance Amount Required"
                value={
                  loading ? (
                    <span className="text-gray-400 italic">Loading…</span>
                  ) : totalRemaining !== null ? (
                    <span className="text-red-500 font-bold">
                      {formatCurrency(totalRemaining)}
                    </span>
                  ) : (
                    <span className="text-gray-400">Unavailable</span>
                  )
                }
              />
            </div>
          </div>
        </div> */}



        {/* ── Online Donation ── */}
        <div className="flex flex-col md:flex-row items-center gap-0 mb-1.5 max-w-[860px] mx-auto px-2 rounded-2xl overflow-hidden">
          {/* Left Div - Online Donation with full blue background */}
          <div className="bg-[#3f7ff4] rounded-l-2xl px-6 py-2.5 shadow-sm w-full md:w-1/3">
            <span className="font-bold text-white text-sm md:text-base whitespace-nowrap text-center block">
              Online Donation
            </span>
          </div>

          {/* Right Div - Donate Link */}
          <a
            href="https://www.tajushshariahfoundation.org/donate"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full md:flex-1 inline-flex items-center justify-center gap-2 rounded-r-2xl border-2 border-[#3f7ff4] bg-white px-4 md:px-6 py-2.5 text-[#3f7ff4] font-bold text-xs md:text-sm shadow-sm transition-shadow hover:shadow-lg"
          >
            www.tajushshariahfoundation.org/donate
          </a>
        </div>

        {/* QR + Bank Cards */}
        <div className="grid grid-cols-1 gap-1.5 mb-1.5">
          {ACCOUNTS.map((account) => (
            <div
              key={account.bank}
              className="w-full grid grid-cols-1 md:grid-cols-[0.9fr_1.4fr] rounded-xl overflow-hidden"
            >
              {/* Left - QR Code Div */}
              <div className="flex items-center justify-center bg-white border border-[#e7e9ee] shadow-sm hover:shadow-md transition-shadow duration-150 p-1.5 md:p-2">
                <div className="w-28 h-28 md:w-36 md:h-36 rounded-lg border border-[#d7dce5] p-1.5 bg-white">
                  <img
                    className="w-full h-full object-contain"
                    src={account.qrImage}
                    alt={account.qrAlt}
                  />
                </div>
              </div>

              {/* Right - Bank Details Div */}
              <div className="flex flex-col bg-white border border-t-0 md:border-t md:border-l-0 border-[#e7e9ee] shadow-sm hover:shadow-md transition-shadow duration-150">
                {/* Header Badge */}
                <div className="w-full bg-gradient-to-r from-[#3f7ff4] to-[#2d5ba8] px-4 py-2 md:py-2.5 text-center">
                  <span className="text-white font-bold text-sm md:text-base">{account.bank}</span>
                </div>
                {/* Bank Details Content */}
                <div className="flex-1 p-2.5 md:p-3 flex items-center">
                  <div className="space-y-1.5 md:space-y-2 w-full">
                    <div className="flex items-center justify-between gap-3">
                      <span className="text-[#9aa3b2] font-semibold text-sm">Branch</span>
                      <span className="font-semibold text-[#344054] text-sm text-right">{account.branch}</span>
                    </div>
                    <div className="flex items-center justify-between gap-3">
                      <span className="text-[#9aa3b2] font-semibold text-sm">IFSC</span>
                      <span className="font-semibold text-[#344054] text-sm text-right">{account.ifsc}</span>
                    </div>
                    <div className="flex items-center justify-between gap-3">
                      <span className="text-[#9aa3b2] font-semibold text-sm whitespace-nowrap">Account No.</span>
                      <span className="font-semibold text-[#344054] text-sm text-right">{account.accountNumber}</span>
                    </div>
                    <div className="flex items-start justify-between gap-3">
                      <span className="text-[#9aa3b2] font-semibold text-sm whitespace-nowrap">UPI</span>
                      <span className="font-semibold text-[#344054] text-sm text-right break-all">{account.upi}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Note - Moved below QR Cards */}
        <div className="rounded-2xl border border-l-4 border-l-[#f59e0b] border-[#fef3c7] bg-[#fef9e7] text-[#92400e] p-2.5 md:p-3 mx-auto shadow-sm mb-0.5">
          <p className="text-xs md:text-sm leading-relaxed text-justify">
            Agar Aapka Donation Wajib Funds (Zakaat, Fitra, Wajib Sadaqah) Ke Liye Hai To Donation Dete Waqt Hamein Zaroor Batain Taki
            <span className="font-semibold"> Hilah Shari'ah</span> Ke Hisaab Se Handle Ho. Warna
            <span className="font-semibold"> Nafli (Optional) Charity</span> Maana Jayega.
          </p>
        </div>

      </main>

      {/* ── Footer ── */}
      <footer className="bg-white border-t border-[#e2e8f0] py-3 md:py-4 px-4 md:px-8">
        <div className="max-w-[860px] mx-auto flex flex-col md:flex-row items-start justify-start md:justify-between gap-3 md:gap-4">
          {/* Left — TajushShariah Foundation */}
          <a
            href="http://www.tajushshariahfoundation.org"
            target="_blank"
            rel="noopener noreferrer"
            className="flex w-full md:w-auto min-w-0 items-center justify-start gap-2 md:gap-3 hover:opacity-80 transition-opacity text-left"
          >
            <img src="images/TFLogo.svg" alt="TajushShariah Foundation" className="h-6 md:h-8 w-6 md:w-8 flex-shrink-0" />
            <div className="min-w-0">
              <p className="text-transparent bg-clip-text font-extrabold text-xs md:text-sm bg-gradient-to-r from-[#FD6E6A] to-[#FFC600]">
                TajushShariah Foundation
              </p>
              <p className="text-xs text-gray-400 break-words">www.tajushshariahfoundation.org</p>
            </div>
          </a>

          {/* Right — Barelvi */}
          <a
            href="https://www.barelvi.org"
            target="_blank"
            rel="noopener noreferrer"
            className="flex w-full md:w-auto md:ml-auto min-w-0 items-center justify-start gap-2 md:gap-3 hover:opacity-80 transition-opacity text-left"
          >
            <img
              src="images/BarelviLogo.png"
              alt="Barelvi"
              className="h-6 md:h-8 w-6 md:w-8 object-contain rounded-full flex-shrink-0"
            />
            <div className="min-w-0">
              <p className="font-extrabold text-xs md:text-sm text-[#3f7ff4]">Barelvi</p>
              <p className="text-xs text-gray-400 break-words">www.barelvi.org</p>
            </div>
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Announcement1;
